import { REGISTER_USER, REGISTER_USER_SUCCESSFUL, REGISTER_USER_FAILED } from './actionTypes';

export const registerUser = (user) => {
    return {
        type: REGISTER_USER,
        payload: { user }
    }
}

export const registerUserSuccessful = () => {
    return {
        type: REGISTER_USER_SUCCESSFUL
    }
}

export const registerUserFailed = () => {
    return {
        type: REGISTER_USER_FAILED,
    }
}
